import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';

@Injectable({
  providedIn: 'root'
})
export class EncryptService {
  private key = CryptoJS.enc.Utf8.parse('haOHfcJQPlfaxpJG');
  private iv = CryptoJS.enc.Utf8.parse('haOHfcJQPlfaxpJG');

  constructor() {}

  encrypt(text: string) {
    const encrypted = CryptoJS.AES.encrypt(
      CryptoJS.enc.Utf8.parse(text),
      this.key,
      this.getAlgoritmo()
    );
    return encrypted.toString();
  }

  decrypt(decString: string) {
    const decrypted = CryptoJS.AES.decrypt(decString, this.key, this.getAlgoritmo());
    return decrypted.toString(CryptoJS.enc.Utf8);
  }

  private getAlgoritmo() {
    return {
      keySize: 128 / 8,
      iv: this.iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    };
  }
}
